import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";

import BreadCrumb from "common/breadcrumb";
import { BrandingData } from "admin-portal/settings/branding";
import ProductListComponent from "admin-portal/components/product-list";

import { AppUtility } from "utility/app-utility";
import { Product } from "models/setup/product";
import { LabelValuePair } from "models/label-value";

import { GetProducts } from "api/setup";

const ProductReport: React.FC = () => {
  document.title = "Products" + BrandingData.titleSuffix;
  const title = "Products Report";
  const pageTitle = "Products";
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [products, setProducts] = useState<Product[] | undefined>([]);
  const [productSelectOptions, setProductSelectOptions] = useState<LabelValuePair[]>([]);

  useEffect(() => {
    loadReportData();
  }, []);

  const loadReportData = async () => {
    setLoading(true);
    const param: any = {};
    const res = await GetProducts(param);
    if (!(res?.status?.isError ?? false) && res?.data) {
      let _st = (res?.data ?? []).map((t, index) => ({
        value: (t.id ?? 0).toString(),
        label: `${t.name ?? ""} (${(t.price ?? 0.0).toFixed(2)})`,
      }));
      if (_st) {
        _st = _st.sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()));
      }
      setProducts(res?.data ?? []);
      setProductSelectOptions(_st);
    } else {
      setProducts([]);
      setProductSelectOptions([]);
    }
    setLoading(false);
  };

  return (
    <React.Fragment>
      <BreadCrumb title={title} pageTitle={pageTitle} />
      <div className="min-w-[50%]">
        <div className="card">
          <div className="card-body">
            <ProductListComponent viewOnly={true}></ProductListComponent>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ProductReport;
